export enum PortfolioHoldingsResolutionRedirectOrigin {
	PARTNER_IMPORT_DIALOG = 'PARTNER_IMPORT_DIALOG',
	SAVED_PORTFOLIOS = 'SAVED_PORTFOLIOS'
}
